<template>
  <div class="row my-2">
    <label class="col-8" :for="id" :class="{ checked: value }">{{ label }}</label>
    <div class="col-4">
      <el-switch
        @change="$emit('change', $event)"
        class="float-right"
        :id="id"
        :inactive-text="value ? $t('general.yes') : $t('general.no')"
        :value="value"
      ></el-switch>
    </div>
  </div>
</template>

<script>
import { Switch } from 'element-ui';

export default {
  props: {
    id: {
      type: String
    },
    label: {
      type: String
    },
    value: {
      type: Boolean
    }
  },
  components: {
    elSwitch: Switch
  }
};
</script>

<style lang="scss" scoped>
@import '@shared/styles/_colors.scss';
label {
  color: $color-secondary;
  font-size: var(--text-size-small);
}
</style>

<style lang="scss">
@import '@shared/styles/_colors.scss';
.el-switch__label,
.el-switch__label span {
  color: $color-primary !important;
  font-size: var(--text-size-small) !important;
  font-weight: normal !important;
}
.el-switch.is-checked .el-switch__core,
.el-switch__core {
  background-color: rgba(2, 28, 44, 0.03) !important;
  border-color: rgba(2, 28, 44, 0.03) !important;
}

.el-switch__label.is-active span {
  color: $color-secondary !important;
}

.el-switch.is-checked .el-switch__core:after {
  background-color: rgba(2, 28, 44, 0.3) !important;
}

.el-switch .el-switch__core:after {
  background-color: rgb(255, 255, 255) !important;
}
</style>
